if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	
	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	
	if (oldTag) {
  oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
} else {
  document.head.appendChild(linkTag);
}
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"vendors-node_modules_pnpm_syncfusion_ej2-grids_27_1_52_node_modules_syncfusion_ej2-grids_styl-fb2e69": 1,
"vendors-node_modules_pnpm_syncfusion_ej2-schedule_27_1_52_node_modules_syncfusion_ej2-schedul-f638da": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_EditReservation_HistoricalReservationMod-913c62": 1,
"Sales_js_SalesDashboard_SalesDashboardComponent_tsx": 1,
"Sales_js_Macros_MacrosComponent_tsx": 1,
"vendors-node_modules_pnpm_syncfusion_ej2-notifications_27_1_50_node_modules_syncfusion_ej2-no-8b2b68": 1,
"Sales_js_MacroRouting_MacroRoutingComponent_module_scss": 1,
"Sales_js_Vouchers_GroupNodeComponent_tsx": 1,
"vendors-Components_js_node_modules_pnpm_digitalopsdev_serviceops-docs-components_2_0_7_e81383-c21d7e": 1,
"Sales_js_Vouchers_EffectsComponent_tsx": 1,
"Sales_js_Vouchers_ScheduleWrapperComponent_tsx": 1,
"Sales_js_Settings_SettingsComponent_tsx-Sales_js_MacroRouting_MacroRoutingComponent_module_scss": 1,
"Sales_js_PublicPriceCheck_PublicPriceCheckComponent_tsx-node_modules_pnpm_react-international-385d78": 1,
"vendors-node_modules_pnpm_syncfusion_ej2-react-grids_27_1_52_node_modules_syncfusion_ej2-reac-9e0e28": 1,
"vendors-node_modules_pnpm_measured_puck_0_20_2__types_react_18_3_9_immer_10_1_1_react-dom_18_-f2ccf8": 1,
"vendors-node_modules_pnpm_syncfusion_ej2-querybuilder_27_1_52_node_modules_syncfusion_ej2-que-1415b7": 1,
"vendors-node_modules_pnpm_syncfusion_ej2-layouts_27_1_51_node_modules_syncfusion_ej2-layouts_-c7cc2e": 1,
"Components_js_dist_phuketfit_css": 1,
"vendors-Components_js_node_modules_pnpm_vidstack_react_1_12_13__types_react_18_3_26_react_18_-911370": 1,
"vendors-Components_js_node_modules_pnpm_vidstack_react_1_12_13__types_react_18_3_26_react_18_-6a0fcf": 1,
"ServiceOps_node_modules_pnpm_syncfusion_ej2-react-calendars_27_2_3_node_modules_syncfusion_ej-f2dbe3": 1,
"vendors-ServiceOps_node_modules_pnpm_syncfusion_ej2-base_27_2_5_node_modules_syncfusion_ej2-b-288e92": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-splitbuttons_27_2_2_node_modules_syncf-84c699": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-dropdowns_27_2_5_node_modules_syncfusi-c98777": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-calendars_27_2_3_node_modules_syncfusi-eafc8c": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-buttons_27_2_4_node_modules_syncfusion-a0e1b7": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-base_27_2_5_node_modules_syncfusion_ej-52ce2f": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_utils_syncfusionOverrides_css": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_EditReservation_ProgramRowComponent_tsx_-f692ae": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-popups_27_2_2_node_modules_syncfusion_-46a37d": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_EditReservation_SaveReservationComponent_js": 1,
"vendors-node_modules_pnpm_syncfusion_ej2-calendars_27_1_52_node_modules_syncfusion_ej2-calend-c9910a": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-lists_27_2_5_node_modules_syncfusion_e-d5a818": 1,
"vendors-Components_js_node_modules_pnpm_syncfusion_ej2-inputs_27_2_4_node_modules_syncfusion_-827117": 1,
"ServiceOps_node_modules_pnpm_syncfusion_ej2-react-calendars_27_2_3_node_modules_syncfusion_ej-f2b9db": 1,
"Sales_js_OccupancyReport_OccupancyReportComponent_tsx": 1,
"vendors-node_modules_pnpm_syncfusion_ej2-dropdowns_27_1_52_node_modules_syncfusion_ej2-dropdo-43be1d": 1,
"Sales_js_Sales_SearchComponent_tsx": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_EditReservation_ProfileComponent_js-Serv-fcb31f": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_utils_loadSyncfusion_js": 1,
"Sales_js_Quotes_QuotesComponent_tsx_css-js_app_css": 1,
"vendors-ServiceOps_node_modules_pnpm_syncfusion_ej2-buttons_27_2_4_node_modules_syncfusion_ej-4a2321": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_Vouchers_ScheduleWrapperComponent_js": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_Rates_RatesComponent_js": 1,
"Sales_js_FakeZendeskLogViewer_FakeZendeskLogViewerComponent_tsx": 1,
"Sales_js_RevenueReport_RevenueReportComponent_tsx": 1,
"Sales_js_ContactFormReport_ContactFormReportComponent_tsx": 1,
"Sales_js_Vouchers_VouchersComponent_tsx": 1,
"ServiceOps_ServiceOps_ReservationsComponents_js_dist_Credits_CreditsEditorComponent_js-Servic-c3f547": 1,
"vendors-ServiceOps_node_modules_pnpm_syncfusion_ej2-calendars_27_2_3_node_modules_syncfusion_-db0473": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,
				fullhref,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

